/**
 * Gets age with the given date.
 * @param  {Date} date
 * @returns {number}
 */
import { replaceLastMatchStringUtil } from 'utils/string'

function getAgeDatetimeUtil (date) {
  const today = new Date()
  const birthDate = new Date(date)
  let age = today.getFullYear() - birthDate.getFullYear()
  const diff = today.getMonth() - birthDate.getMonth()
  if (diff < 0 || (diff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

/**
 * Gets the relative time between now and a given date.
 * @param  {Date} date
 * @param  {Date} [shouldUseJustNow = true]
 * @returns {string}
 */
function fromNowDatetimeUtil (date, shouldUseJustNow = true) {
  const delta = Math.round((new Date() - date) / 1000)
  const today = new Date()
  const minute = 60
  const hour = minute * 60
  const day = hour * 24
  const week = day * 7
  const month = day * 30
  const year = day * 365
  if (delta <= 1) {
    return shouldUseJustNow ? 'just now' : '1 second ago'
  }
  if (delta < minute) {
    return shouldUseJustNow ? 'just now' : delta + ' seconds ago'
  }
  if (delta < minute * 2) {
    return '1 minute ago'
  }
  if (delta < hour) {
    return Math.floor(delta / minute) + ' minutes ago'
  }
  if (Math.floor(delta / hour) === 1) {
    return '1 hour ago'
  }
  if (delta < day) {
    return Math.floor(delta / hour) + ' hours ago'
  }
  if (delta < day * 2 && (date.getDay() + 1) % 7 === today.getDay()) {
    return 'Yesterday'
  }
  if (delta < week && today.getDay() !== date.getDay()) {
    return ((today.getDay() - date.getDay() + 7) % 7) + ' days ago'
  }
  if (delta < day * 14) {
    return '1 week ago'
  }
  if (delta < month) {
    return Math.floor(delta / week) + ' weeks ago'
  }
  if (delta < month * 2) {
    return '1 month ago'
  }
  if (delta < year) {
    return Math.floor(delta / month) + ' months ago'
  }
  if (delta < year * 2) {
    return '1 year ago'
  }
  return Math.floor(delta / year) + ' years ago'
}

/**
 * Returns an human readable string based on the given date.
 *
 * @example
 * ```jsx
 * let date = new Date
 * toHumanReadableStringDatetimeUtil(date) => 'April 25, 2016'
 * ```
 *
 * @param  {Date} date
 * @returns {string}
 */
function toHumanReadableStringDatetimeUtil (date) {
  const humanReadable = date.toDateString()
    .split(' ')
    .slice(1)
    .join(' ')
  return replaceLastMatchStringUtil(humanReadable, ' ', ', ')
}

function formatDatetimeUtil (value) {
  const date = new Date(value)
  let month = '' + (date.getMonth() + 1)
  let day = '' + date.getDate()
  const year = date.getFullYear()
  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  return [
    year,
    month,
    day
  ].join('-')
}

/**
 * Ads days to the current date.
 * @param  {number} days
 * @returns {Date}
 */
function addDaysDatetimeUtil (days) {
  const date = new Date()
  days = parseInt(days, 10)
  date.setDate(date.getDate() + days)
  return date
}

export {
  getAgeDatetimeUtil,
  fromNowDatetimeUtil,
  toHumanReadableStringDatetimeUtil,
  formatDatetimeUtil,
  addDaysDatetimeUtil
}
